import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { LuDownload } from "react-icons/lu";
import "./ArticlesOfAssociation.style.css";

const ArticlesOfAssociation = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const item = {
    name: { tr: "Esas Sözleşme", en: "Articles of Association" },
    href: { tr: "/static/docs/aoa-tr.pdf", en: "/static/docs/aoa-en.pdf" },
  };

  return (
    <div>
      <Meta
        title={t("articles-of-association") || "Esas Sözleşme"}
        description={t("articles-of-association") || "Esas Sözleşme"}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("articles-of-association") || "Esas Sözleşme"}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="aoa-content">
            <section className="aoa-card">
              <ul className="aoa-list">
                <li className="aoa-row">
                  <span className="aoa-title">{item.name[L] || item.name.en}</span>
                  <a
                    href={item.href[L] || item.href.en}
                    target="_blank"
                    rel="noreferrer"
                    className="aoa-dl"
                    aria-label={(t("download") || "İndir") + ": " + (item.name[L] || item.name.en)}
                  >
                    <LuDownload size={18} />
                  </a>
                </li>
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ArticlesOfAssociation;
